import React, { useState, useEffect } from 'react';
import { GLOBAL_CALCULATIONS } from '../GlobalLogic';

const MainModalE = ({ isopen, onclose, message, okfunction, items, modalitem }) => {
    if (!isopen) return null;
    const internalTotal = GLOBAL_CALCULATIONS.getOrderInternalCost(modalitem);
    const odrprofit = (Number(modalitem.sellingprice) - internalTotal).toFixed(2);
 
    return (
        <div className="modal-overlay">
            <div className="modal-content">
                {/* Modal Header */}
                <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                    <h6 className="fw-bold text-success mb-0">{message}</h6>
                    <button 
                        className="btn-close border-0 bg-transparent fs-4 text-muted" 
                        onClick={onclose}
                        style={{ cursor: 'pointer', lineHeight: '1' }}
                    >
                        {/* &times; */}
                    </button>
                </div>

                {/* Modal Body / Items Grid Layout */}
                <div className="row g-3 mb-3">
                    {Object.entries(items || {}).map(([key, value]) => {
                        const formattedKey = key.replace(/([A-Z])/g, ' $1').replace(/_/g, ' ').trim();
                        
                        return (
                            <div key={key} className="col-12 col-md-6">
                                <div 
                                    className="d-flex justify-content-between align-items-center pb-0 border-bottom border-light"
                                    style={{ fontSize: '13.5px' }}
                                >
                                    <span className={`${value > 0 ? 'text-secondary' : 'text-danger'} fw-medium text-truncate pe-2`}>{formattedKey}</span>
                                    <span className={`${value > 0 ? 'text-dark' : 'text-danger'} fw-bold`}>
                                        {typeof value === 'number' ? `₹${value}` : String(value)}
                                    </span>
                                </div>
                            </div>
                        );
                    })}
                </div>

                {/* Highlighted Profit Section */}
                <div className="mb-4">
                    <div className={`${odrprofit>0?"bg-success-subtle border border-success-subtle":"bg-danger-subtle border border-danger-subtle"} rounded-2 px-3 py-2 d-flex justify-content-between align-items-center`}>
                        <span className="text-success-emphasis fw-bold m-0" style={{ fontSize: '14px' }}>
                            <i className="bi bi-graph-up-arrow me-2"></i>Profit as of now
                        </span>
                        <h5 className={`${odrprofit>0?"text-success":"text-danger"} fw-extrabold mb-0`}>
                            ₹{odrprofit} ({((odrprofit/Number(modalitem.sellingprice))*100).toFixed(1)}%)
                        </h5>
                    </div>
                </div>

                {/* Modal Footer Actions */}
                <div className="d-flex justify-content-end gap-2 pt-2 border-top">
                    <button type="button" className="btn btn-light px-4 fw-medium text-secondary" onClick={onclose}>
                        Cancel
                    </button>
                    <button type="button" className="btn btn-success px-4 fw-medium" onClick={okfunction}>
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MainModalE;